import React, { FC } from "react";

const PaySuccessView: FC = () => <h1>Спасибо за подписку!</h1>;

export default PaySuccessView;
